import { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'

import PaveLogoSimple from 'assets/images/pave-logo-simple.svg'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

import PDSFlexBox from '../PDSFlexBox/PDSFlexBox'
import INTERNALxButton from '../internal/elements/INTERNALxButton'

type Props = {
  rightContent?: ReactElement
  showRightContent?: boolean
}

export default function PDSNavBar({
  rightContent,
  showRightContent = true,
}: Props): ReactElement {
  const navigate = useNavigate()
  const goHome = () => navigate('/')

  return (
    <PDSFlexBox
      backgroundColor={COLOR.content}
      borderBottom={`1px solid ${COLOR.content_border}`}
      justifyContent="space-between"
      paddingY={SIZE.s12}
      paddingX={SIZE.s40}
    >
      <INTERNALxButton onClick={goHome}>
        <img src={PaveLogoSimple} alt="Pave Logo" height={40} width={40} />
      </INTERNALxButton>

      {showRightContent && (
        <PDSFlexBox alignItems="center">{rightContent}</PDSFlexBox>
      )}
    </PDSFlexBox>
  )
}
